module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '79bbgmlr',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
